module.exports = __webpack_public_path__ + "static/media/opakowania_01_B.d1e3ae66.png";